export default "__VITE_ASSET__Cjr_DSlE__"